<template>
  <v-form>
    <gg-text-field
      label="Name"
      name="Name"
      placeholder="Valid zone name"
      v-model="model.domain"
      v-validate="rules.name"
      :error-messages="errors.collect('Name')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="Priority"
      name="Priority"
      placeholder="Integer"
      v-model="model.priority"
      v-validate="rules.priority"
      :error-messages="errors.collect('Priority')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="TTL"
      name="TTL"
      placeholder="14400"
      v-model="model.ttl"
      v-validate="rules.ttl"
      :error-messages="errors.collect('TTL')"
      @input="sendData"></gg-text-field>
    <gg-text-field
      label="Destination"
      name="Destination"
      placeholder="Fully qualified domain name"
      v-model="model.exchanger"
      v-validate="rules.destination"
      :error-messages="errors.collect('Destination')"
      @input="sendData"></gg-text-field>
  </v-form>
</template>

<script>
import { ZoneRecord } from '@/mixins/ZoneRecord'

export default {
  name: 'MXRecordForm',
  mixins: [ZoneRecord],
  inject: ['parentValidator'],
  props: {
    domain: {
      type: String
    },
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      model: {
        domain: '',
        ttl: '14400',
        priority: null,
        exchanger: ''
      },
      rules: {
        name: { required: true },
        priority: {
          required: true,
          numeric: true
        },
        ttl: { required: true, numeric: true },
        destination: {
          required: true,
          url: true
        }
      }
    }
  },
  methods: {
    applyName () {
      this.model.domain = this.domain || ''
    },
    fillEditData () {
      for (let key in this.item) {
        if (this.item.hasOwnProperty(key)) {
          this.model[key] = this.item[key]
        }
      }
    }
  },
  created () {
    this.$validator = this.parentValidator
    if (this.edit) {
      this.fillEditData()
    }
    this.applyName()
    this.sendData()
  }
}
</script>
